// extracted by mini-css-extract-plugin
export default {"socialMediaContainer":"SocialMediaLinks_socialMediaContainer__OaI00","icon":"SocialMediaLinks_icon__vWEi+"};